export function formatAmount(amount: number): string {
  // Convert amount to number and round to 2 decimal places
  const roundedAmount: number = Math.round(amount * 100) / 100;

  // Convert rounded amount to string
  let formattedAmount: string = roundedAmount.toFixed(2);

  // Add $ sign in front of the amount
  formattedAmount = "$" + formattedAmount;

  return formattedAmount;
}
